import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInstagram, FiShield, FiHeart, FiCpu } = FiIcons;

const AUTHOR_IMAGE = 'https://cloud.sharemyimage.com/2026/10/04/EAKross1.png';

export default function AuthorSection() {
  return (
    <section className="section author-section" id="author">
      <motion.div
        className="author-portrait"
        initial={{ opacity: 0, x: -35 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
      >
        <img src={AUTHOR_IMAGE} alt="E.A. Kross, author" />
        <span className="portrait-mark">EAK</span>
      </motion.div>
      <motion.div
        className="author-copy"
        initial={{ opacity: 0, x: 35 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
      >
        <p className="eyebrow">Behind the spellwork</p>
        <h2>Meet <em>E.A. Kross</em></h2>
        <p className="intro">Writer of monsters, magic, and beautifully bad decisions.</p>
        <p>
          E.A. Kross is retired military, and it shows in the work: urban fantasy built on
          discipline, grit, and a healthy respect for the things that go bump in the night.
          Raised in the 1980s on paperback fantasy, Saturday-morning cartoons, and late-night
          ghost stories, Kross now writes in the 2020s, where old-school myth collides with
          modern life.
        </p>
        <p>
          Away from the keyboard, you will find Kross kickboxing, tinkering with the latest
          tech, or at home with a wife and kids who keep life interesting. Faith in God anchors
          it all, and it is why these stories keep asking what power costs and who you choose
          to protect.
        </p>
        <div className="author-meta">
          <span><SafeIcon icon={FiShield} /> Retired military</span>
          <span><SafeIcon icon={FiHeart} /> Faith &amp; family</span>
          <span><SafeIcon icon={FiCpu} /> Tech &amp; kickboxing</span>
          <a href="#top" aria-label="Follow E.A. Kross on Instagram">
            <SafeIcon icon={FiInstagram} /> @eakrosswrites
          </a>
        </div>
      </motion.div>
    </section>
  );
}
